import AppHeader from "../../layout/AppHeader";
import Items from '../../xpost/views/umov/items/Items.vue';
import ItemsAdd from '../../xpost/views/umov/items/ItemsAdd.vue';

const ItemsRoutes = [
  {
    path: "/cadastro/item",
    name: "items",
    components: {
      header: AppHeader,
      default: Items,
    }
  },
  {
    path: "/cadastro/item/adicionar",
    name: "items.add",
    components: {
      header: AppHeader,
      default: ItemsAdd,
    }
  },
  {
    path: "/cadastro/item/editar/:id",
    name: "items.edit",
    components: {
      header: AppHeader,
      default: ItemsAdd,
    }
  },
]

export default ItemsRoutes;